import React from "react";
import { Button, Typography } from "@mui/material";
import { themeColor, themeColorNew } from "../utils";

interface CustomButtonProps {
  loading: boolean;
  disabled?: boolean;
  buttonText: React.ReactNode;
  handleSubmitClick: () => void;
  buttonTextLoading?: React.ReactNode;
  background?: string;
  borderRadius?: string | number;
  border?: string;
  borderDisabled?: string;
  color?: string;
  height?: string;
  hoverBgColor?: string;
  width?: string;
  marginTop?: string | number;
  marginLeft?: string;
  minWidth?: string;
  padding?: string;
}

const CustomButton: React.FC<CustomButtonProps> = ({
  loading,
  disabled = false,
  buttonText,
  handleSubmitClick,
  buttonTextLoading,
  background,
  borderRadius,
  border,
  borderDisabled,
  color,
  height,
  hoverBgColor,
  width,
  marginTop,
  marginLeft,
  minWidth,
  padding,
}) => {
  return (
    <Button
      variant="outlined"
      type="submit"
      disabled={loading || disabled}
      onClick={handleSubmitClick}
      loading={loading}
      loadingPosition="end"
      sx={{
        background: background ?? themeColor,
        color: color ?? "common.white",
        borderRadius: borderRadius ?? 20,
        height: height ?? "35px",
        marginLeft: marginLeft ?? "0px",
        width: width ?? "fit-content",
        marginTop: marginTop ?? 0,
        border: border ?? "none",
        padding: padding,
        minWidth: minWidth ?? "auto",
        "&.Mui-disabled": {
          opacity: 0.8,
          background: background ?? "transparent",
          padding: padding,
          cursor: "not-allowed",
          border: borderDisabled,
          pointerEvents: "all",
        },
        "&:hover": {
          background: hoverBgColor ?? ((loading || disabled) ? "white" : themeColorNew),
        },
      }}
    >
      <Typography
        component="span"
        variant="body2"
        sx={{ textTransform: "none", display: "flex", alignItems: "center", gap: 0.5, flexDirection: "row" }}
      >
        {loading ? buttonTextLoading : buttonText}
      </Typography>
    </Button>
  );
};

export default CustomButton;
